import React from 'react';
import BlockRulesPage from './BlockRulesPage';
interface PurposePaymentBlockProps {
  onLogout: () => void;
}
const PurposePaymentBlock: React.FC<PurposePaymentBlockProps> = ({
  onLogout
}) => <BlockRulesPage kind="purpose" onLogout={onLogout} data-id="element-4378" data-mp="gkf1vx6qxq7t" />;
export default PurposePaymentBlock;